var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$options.components && _vm.$options.components[_vm.playerComponent])?_c(_vm.playerComponent,{tag:"Component",attrs:{"type":_vm.type,"data":_vm.data,"ads":_vm.ads}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }